module.exports = __webpack_public_path__ + "static/earthSpeakr_logo_black-0fa030f3884992167a9c620b2340edf7.png";